(function () {
  function init() {
    var header = document.querySelector('[data-blit-header]');
    if (!header || header.dataset.bhReady === '1') return;
    header.dataset.bhReady = '1';

    var promo = header.querySelector('[data-bh-promo]');
    if (promo) {
      var items = promo.querySelectorAll('.bh__promo-item');
      if (items.length > 1) {
        var i = 0;
        setInterval(function () {
          items[i].classList.remove('is-on');
          i = (i + 1) % items.length;
          items[i].classList.add('is-on');
        }, 4000);
      }
    }

    var spacer = document.createElement('div');
    spacer.style.display = 'none';
    header.parentNode.insertBefore(spacer, header.nextSibling);

    var stuck = false;
    var threshold = 0;

    function measure() {
      if (!stuck) threshold = header.offsetTop + header.offsetHeight;
    }
    measure();
    window.addEventListener('resize', function () { if (!stuck) measure(); });

    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      if (!stuck && y > threshold) {
        spacer.style.height = header.offsetHeight + 'px';
        spacer.style.display = 'block';
        header.classList.add('is-stuck');
        stuck = true;
      } else if (stuck && y <= threshold) {
        header.classList.remove('is-stuck');
        spacer.style.display = 'none';
        stuck = false;
        measure();
      }
    }, { passive: true });

    var drawer = header.querySelector('[data-bh-drawer]');
    var burger = header.querySelector('[data-bh-burger]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (burger) burger.addEventListener('click', openDrawer);
    header.querySelectorAll('[data-bh-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    header.querySelectorAll('[data-bh-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = btn.nextElementSibling;
        var open = btn.classList.toggle('is-open');
        if (sub) sub.classList.toggle('is-open', open);
      });
    });

    var countEl = header.querySelector('[data-bh-count]');
    function refreshCount() {
      if (!countEl) return;
      fetch((window.routes ? window.routes.cart_url : '/cart') + '.js')
        .then(function (r) { return r.json(); })
        .then(function (c) {
          countEl.textContent = c.item_count;
          countEl.classList.toggle('is-empty', c.item_count === 0);
        })
        .catch(function () {});
    }
    if (countEl) {
      document.addEventListener('cart:updated', refreshCount);
      document.addEventListener('cart:refresh', refreshCount);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
